import React from 'react';
import { Grid, Link, IconButton, CircularProgress } from '@mui/material';
import GadgetLoader from '../../Loaders/GadgetLoader';
import EnhancedDataGrid from '../../Common/EnhancedDataGrid';
import Tooltip from '@mui/material/Tooltip';
import { formatNumber, formatDate, defaultStringIfNullOrEmpty, getDisplayName } from '../../Common/Utilities';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import ReplayIcon from '@mui/icons-material/Replay';
import { Constants } from '../../Common/Constants';


const BottomRightGadget = ({
	xsVal,
	gridCss,
	keyVal,
	thisRef,
	fontStyle,
	cellStyle,
	hasSearchedOnce
}) => {
	const { modelDefId } = thisRef.state;
	const effectiveModelDefId = Number(thisRef.props.modelDefId ?? modelDefId);

	const renderSmartText = React.useCallback((text) => {
		const value = (text ?? '').toString();
		const hasWhitespace = /\s/.test(value);

		const style = hasWhitespace
			? {
				display: '-webkit-box',
				WebkitLineClamp: 2,
				WebkitBoxOrient: 'vertical',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				wordBreak: 'normal',
				overflowWrap: 'break-word',
				whiteSpace: 'normal',
				lineHeight: 1.3,
			}
			: {
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
				display: 'block',
				lineHeight: 1.3,
			};

		return (
			<Tooltip title={value} placement="top-start">
				<span style={style}>{value}</span>
			</Tooltip>
		);
	}, []);
	const isAdmin = thisRef.isAdmin;
	const props = thisRef.props;

	const isPostInProgressRow = React.useCallback((row) => {
		return Number(row?.invoiceDocumentPostingStatusId) === 30;
	}, []);

	const handleRowReload = React.useCallback((invoiceDocumentId) => {
		if (!invoiceDocumentId) return;
		if (thisRef.isInvoiceRowReloading(invoiceDocumentId)) return;

		// Match Dashboard refresh behavior: keep the user's weeks selection if they changed it, otherwise use auto (-1).
		const weeksToUse = thisRef.state.userHasSetWeeks?.[4] ? (thisRef.state.weeksToFilter4 ?? 0) : -1;
		const searchText = thisRef.getFilterText(4) || '';
		thisRef.fetchDashboard(4, weeksToUse, searchText, false, invoiceDocumentId);
	}, [thisRef]);

	const isWeeksToFilterSearchActive = React.useMemo(() => {
		const text = thisRef.state.filterText[4];
		const prev = thisRef.state.prevSearchText[4];
		const weeks = thisRef.state.weeksToFilter4;
		return (
			(text !== '' && weeks !== 0) ||
			(weeks === 0 && text === prev && text.trim() !== '')
		);
	}, [thisRef.state.filterText[4], thisRef.state.prevSearchText[4], thisRef.state.weeksToFilter4]);
	const serverProps = React.useMemo(() => { return thisRef.state.serverMode[4] && thisRef.state.weeksToFilter4 === 0 ? { filterMode: "server" } : {} }, [thisRef.state.serverMode[4], thisRef.state.weeksToFilter4])
	const toolTipMessage = React.useMemo(() => { return (thisRef.state.serverMode[4] && thisRef.state.weeksToFilter4 === 0) ? thisRef.toolTipMessage : '' }, [thisRef.state.weeksToFilter4, thisRef.state.serverMode[4]]);
	return <Grid item xs={xsVal} className="fade-in" key={keyVal}>
		<div style={{ position: "relative", ...gridCss }}>
			<GadgetLoader loading={thisRef.state.gadgetLoading[4]} />
			<EnhancedDataGrid rows={thisRef.state.approvedInvoices}
				disableColumnMenu
				pagination
				title={"Approved Invoices"}
				pageSize={thisRef.state.pageSize}
				toolTipMessage={toolTipMessage}
				hasSearchedOnce={hasSearchedOnce}
				{...serverProps}
				onSearchFocus={() => thisRef.handleSearchFocus(4)}
				searchCallback={
					null
					//(searchText) => {
					//const trimmedText = (searchText || "").trim();
					//const prevText = thisRef.state.prevSearchText[4];

					//if (trimmedText === "" && prevText !== "") {
					//	thisRef.setState((prevState) => ({
					//		prevSearchText: {
					//			...prevState.prevSearchText,
					//			4: ""
					//		}
					//	}), () => {
					//		thisRef.fetchDashboard(4, thisRef.state.weeksToFilter4 ?? 0, searchText);
					//	});
					//	return;
					//}

					//if (trimmedText !== "" && trimmedText !== prevText) {
					//	thisRef.setState((prevState) => ({
					//		prevSearchText: {
					//			...prevState.prevSearchText,
					//			4: trimmedText
					//		}
					//	}), () => {
					//		thisRef.fetchDashboard(4, thisRef.state.weeksToFilter4 ?? 0, searchText);
					//	});
					//}
					//}
				}
				//showSearchTooltip={
				//	thisRef.state.switchToFullScreen &&
				//	thisRef.state.showGadget === 4 &&
				//	thisRef.state.showSearchTooltip 
				//}
				showSearchTooltip={false}
				gridRef={thisRef.invoiceApprovedGridRef}
				setFilterText={(text) => { thisRef.setFilterText(4, text) }}
				filterText={thisRef.state.filterText[4]}
				isWeeksToFilterSearchActive={isWeeksToFilterSearchActive}
				sortModel={thisRef.state.sortModel[4]}
				onSortModelChange={(model) => thisRef.setSortModel(4, model)}
				rowsPerPageOptions={thisRef.state.rowsPerPage}
				footerMessage={''}
				getRowClassName={
					thisRef.getDashboardRowClassName
				}
				onRowClick={(params, event) => thisRef.handleDashboardRowClick(4, params, event)}
				columns={[
					{
						headerName: 'Vendor Name',
						field: 'vendorName',
						cellStyle: cellStyle,
						flex: 1,
						renderCell: (rowData) => renderSmartText(thisRef.displayVendorName(rowData.row))
					},
					...(effectiveModelDefId === 3 ? [{
						headerName: 'Media Type',
						field: 'mediaType',
						width: 100,
						cellStyle: cellStyle,
						renderCell: (rowData) => renderSmartText(rowData?.row?.mediaType || '')
					}] : []),
					...((thisRef.state.isExpanded) ? [{
						headerName: 'Client',
						field: 'clientNameCode',
						flex: 1,
						cellStyle: cellStyle
						,
						renderCell: (rowData) => renderSmartText(rowData?.row?.clientNameCode || '')
					}] : []),
					{
						headerName: 'Invoice Number',
						field: 'invoiceNumber',
						width: 120,
						cellStyle: cellStyle
						,
						renderCell: (rowData) => renderSmartText(rowData?.row?.invoiceNumber || '')
					},
					...((thisRef.state.isExpanded) ? [{
						headerName: getDisplayName('User Status'),
						field: 'invoiceUserStatus',
						cellStyle: cellStyle,
						renderCell: rowData => renderSmartText(rowData.row.invoiceUserStatus)
					}] : []),
					...((thisRef.state.isExpanded) ? [{
							headerName: 'Net Amount',
						field: 'netAmount',
						type: 'currency',
						align: 'right',
						headerAlign: 'right',
						renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.netAmount) + " " + defaultStringIfNullOrEmpty(rowData.row.currencyCode, "")}</span>,
						flex: 1
					}] : []),
					...((thisRef.state.isExpanded) ? [{
						headerName: 'Tax Amount',
						field: 'taxAmount',
						type: 'currency',
						align: 'right',
						headerAlign: 'right',
						renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.taxAmount) + " " + defaultStringIfNullOrEmpty(rowData.row.currencyCode, "")}</span>,
						flex: 1
					}] : []),
					{
						headerName: 'Total Invoice Amt',
						field: 'totalAmount',
						width: 120,
						type: 'currency',
						align: 'right',
						headerAlign: 'right',
						headerStyle: {
							textAlign: 'right',
						},
						cellStyle: {
							paddingRight: 8,
							fontSize: 12
						},
						renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.totalAmount) + " " + rowData.row.currencyCode}</span>
					},

						{
							headerName: 'Date Approved',
							field: 'approvalRejectionUpdateDate',
							type: 'datetime',
							valueGetter: ({ value }) => (value ? new Date(value) : null),
							valueFormatter: ({ value }) => value
								? new Intl.DateTimeFormat('en-US', {
									timeZone: 'UTC',
									year: 'numeric',
									month: 'numeric',
									day: 'numeric',
									hour: 'numeric',
									minute: '2-digit',
									second: '2-digit',
									hour12: true,
								}).format(value)
								: '',
							flex: 1,
							cellStyle: cellStyle
						},
						{
							headerName: 'Last Approved By',
							field: 'approvedBy',
							flex: 1,
							cellStyle: cellStyle
							,
							renderCell: (rowData) => renderSmartText(rowData?.row?.approvedBy || '')
						},
						{
							headerName: 'Status',
							field: 'pendingStatus',
							cellStyle: cellStyle,
							flex: 1,
							minWidth: 80,
							maxWidth: 140,
							renderCell: (rowData) => {
								const row = rowData?.row;
								const invoiceDocumentId = row?.invoiceDocumentId;
								const isReloading =
									!!invoiceDocumentId && thisRef.isInvoiceRowReloading(invoiceDocumentId);
								const isPostInProgress = isPostInProgressRow(row);

								return (
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											width: '100%',
											gap: isReloading ? 6 : 4, // 👈 small gap normally, larger when spinner shows
										}}
									>
										{/* Status text */}
										<Tooltip title={
											row?.postedUserName
												? `${row?.pendingStatus} By: ${row.postedUserName}`
												: row?.pendingStatus || ''} placement="top-start">
											<span
												style={{
													flex: 1,
													display: '-webkit-box',
													WebkitLineClamp: 2,
													WebkitBoxOrient: 'vertical',
													overflow: 'hidden',
													wordBreak: 'normal',
													overflowWrap: 'break-word',
													textOverflow: 'ellipsis',
													whiteSpace: 'normal',
													lineHeight: 1.3,
													cursor: 'default',
												}}
											>
												{row?.pendingStatus || ''}
											</span>
										</Tooltip>

										{/* Spinner — rendered ONLY when reloading */}
										{isReloading && (
											<div
												style={{
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													flexShrink: 0,
												}}
											>
												<CircularProgress size={18} />
											</div>
										)}

										{/* Reload button (Post In Progress only) */}
										{isPostInProgress && !isReloading && (
											<Tooltip title="Reload">
												<IconButton
													size="small"
													onClick={(e) => {
														e.preventDefault();
														e.stopPropagation();
														handleRowReload(invoiceDocumentId);
													}}
													aria-label="Reload"
												>
													<ReplayIcon fontSize="small" />
												</IconButton>
											</Tooltip>
										)}

										{/* Error indicator */}
										{row?.invoiceDocumentStatusId === 180 && (
											<Tooltip title={row?.invoiceDocumentPostingErrorMessage || ''}>
												<ErrorIcon
													style={{ marginLeft: 4 }}
													color="secondary"
													onClick={(e) => e.stopPropagation()}
												/>
											</Tooltip>
										)}
									</div>
								);
							}

						},
					//{
					//	headerName: 'View',
					//	field: 'view',
					//	cellStyle: cellStyle,
					//	width: 100, resizable: false, sortable: false,
					//	renderCell: rowData => {
					//		let mode = Constants.VIEW;
					//		let statusMaxed = ((((rowData?.row?.routingNumberOfApprovals || 0)) * 20) + 50) <= rowData?.row?.invoiceDocumentStatusId;
					//		let applyToInvoiceDoucmentId = rowData?.row?.applyToInvoiceDocumentId || 0;
					//		let editLinkDisplay = isAdmin
					//			&& (props?.modelDefId === 2 || props?.modelDefId === 1)
					//			&& statusMaxed
					//			&& (rowData?.row?.invoiceDocumentStatusId < 170);
					//		if (applyToInvoiceDoucmentId > 0) {
					//			mode = Constants.CREDIT_MEMO;
					//		}
					//		else {
					//			if (editLinkDisplay) {
					//				mode = Constants.EDIT_DATES
					//			}
					//			if (editLinkDisplay && rowData?.row?.approvedBy.indexOf(Constants.SYSTEM) !== -1) {
					//				mode = Constants.OVERRIDE;
					//			}
					//		}

					//		return <Link data-rowid={rowData.row.rowId} data-source="approvedInvoices" data-mode={mode} href="#" onClick={thisRef.invoiceDocument_clickHandler}>View</Link>
					//		//: <div>
					//		//	<Link data-rowid={rowData.row.rowId} data-source="approvedInvoices" data-mode="View" href="#" onClick={thisRef.invoiceDocument_clickHandler}>View</Link> /
					//		//	<span>
					//		//	<Link data-rowid={rowData.row.rowId} data-source="approvedInvoices" data-mode={Constants.EDIT_DATES} href="#" onClick={thisRef.invoiceDocument_clickHandler}>Edit Invoice</Link> 
					//		//	</span>

					//		//</div> 
					//	}
					//}
				]}
				customcomponent={<>
					{thisRef.getOpenInFullScreenButton(4)}
					{thisRef.getRefreshButton(4)}
					{thisRef.getWeeksToFilterDropDown(4)}
					{thisRef.getSearchButton(4)}
				</>}
				options={{
					minBodyHeight: 320,
					maxBodyHeight: 320,
					headerStyle: fontStyle,
					searchFieldStyle: fontStyle
				}}
				quickFilterDebounceMs={thisRef.getQuickFilterDebounceMs(4)}
				getRowId={(row) => row.rowId}
				disableRowSelectionOnClick
			/>
		</div>
	</Grid>

};

export default BottomRightGadget;